import React, { useState } from 'react';
import '../App.css';
import './tool.css';
import CSS from 'csstype';

// images

// classes
import { AbbreviatedText } from '../utils/functions';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

//
//	ToolButtonType should be supplied. If not, the component assumes a PRIMARY type.
//

export enum ToolButtonType {
  PRIMARY, // use the prominent colour
  SECONDARY, // use the less prominent colour
  TRANSPARENT, // use a border, but a transparent background
  NONE, // use no border or background
} // ToolButtonType

//
//	ToolButtonWidth will default depending on button type, but this can be changed by
//	supplied a value instead.
//

export enum ToolButtonWidth {
  WIDE,
  STANDARD,
  NARROW,
} // ToolButtonWidth

//
//	ToolButtonColour will default depending on button type, but this can be changed by
//	supplied a value instead.
//

export enum ToolButtonColour {
  PINK,
  RED,
  GREEN,
  BLUE,
  AMBER,
  NONE,
} // ToolButtonColour

export default function ToolButton(props: {
  name: string;
  icon?: string;
  disabledIcon?: string;
  text: string;
  onClick: any;
  tooltip?: string;
  disabled?: boolean;
  selected?: boolean;
  type?: ToolButtonType;
  width?: ToolButtonWidth;
  colour?: ToolButtonColour;
  darkBackground?: boolean;
}) {
  //	------------------------------------------------------------
  //
  //	Component code
  //
  //	------------------------------------------------------------

  // check if type, width, and colour parameters are provided.
  var toolButtonType: ToolButtonType =
    props.type !== undefined ? props.type : ToolButtonType.PRIMARY;
  var toolButtonWidth: ToolButtonWidth =
    props.width !== undefined ? props.width : ToolButtonWidth.STANDARD;
  var toolButtonColour: ToolButtonColour =
    props.colour !== undefined
      ? props.colour
      : props.type === ToolButtonType.SECONDARY
        ? ToolButtonColour.BLUE
        : props.type === ToolButtonType.TRANSPARENT
          ? ToolButtonColour.NONE
          : ToolButtonColour.PINK;

  // do we need to display an icon or not?
  return (
    <button
      id={props.name}
      name={props.name}
      type="button"
      className={props.icon !== undefined ? 'button-with-icon' : 'button'}
      onClick={props.onClick}
      disabled={props.disabled === true}
      data-type={
        toolButtonType === ToolButtonType.PRIMARY
          ? 'PRIMARY'
          : toolButtonType === ToolButtonType.SECONDARY
            ? 'SECONDARY'
            : toolButtonType === ToolButtonType.TRANSPARENT
              ? 'TRANSPARENT'
              : toolButtonType === ToolButtonType.NONE
                ? 'NONE'
                : 'NONE'
      }
      data-width={
        toolButtonWidth === ToolButtonWidth.WIDE
          ? 'WIDE'
          : toolButtonWidth === ToolButtonWidth.NARROW
            ? 'NARROW'
            : 'STANDARD'
      }
      data-colour={
        toolButtonColour === ToolButtonColour.BLUE
          ? 'BLUE'
          : toolButtonColour === ToolButtonColour.RED
            ? 'RED'
            : toolButtonColour === ToolButtonColour.GREEN
              ? 'GREEN'
              : toolButtonColour === ToolButtonColour.NONE
                ? 'NONE'
                : toolButtonColour === ToolButtonColour.AMBER
                  ? 'AMBER'
                  : 'PINK'
      }
    >
      {props.icon !== undefined && (
        <div
          style={{
            float: 'left',
            height: '24px',
            marginLeft: '2px',
            alignItems: 'center',
          }}
        >
          <img src={props.icon} role="presentation" alt="" width="24" height="24" />
        </div>
      )}

      <div
        className="button-text-container"
        style={{ overflow: 'auto' }}
        data-align={toolButtonType === ToolButtonType.TRANSPARENT ? 'L' : 'C'}
      >
        <AbbreviatedText text={props.text} />
      </div>
    </button>
  );
} // ToolButton
